import React, { useEffect, useState } from "react";
import styled from "@emotion/styled";
import { getYMD } from "utils/commonUtil";
import axios from "axios";
import ModalLayout from "admin/component/modal/ModalLayout";
import ConfirmModal from "admin/component/modal/ConfirmModal";
import { ReactComponent as Trash } from "../../../../assets/trash_can.svg";
import Toggle from "../../../component/toggle";
import { BannerProps } from "../BannerAdmin";
import * as api from "../../../../api/api";

interface Props {
  item: BannerProps;
  showMenu?: boolean;
  onClickItem?: () => void;
  callback?: () => void;
}

const BannerCard: React.FC<Props> = (props) => {
  const [bannerItem, updateBannerItem] = useState<BannerProps>(props.item);
  const [deleteConfirmOpen, updateDeleteConfirmOpen] = useState<boolean>(false);
  const onClickContent = () => {
    if (props.onClickItem) {
      props.onClickItem();
    }
  };

  const onClickDelete = async () => {
    try {
      const result = await axios.delete(
        api.deleteBanner(props.item.hpBannerId)
      );
      if (result.status === 200 && props.callback) {
        updateDeleteConfirmOpen(false);
        props.callback();
      }
    } catch (error) {
      console.log(error);
    }
  };

  const onClickToggle = (changeSate: boolean) => {};

  useEffect(() => {
    updateBannerItem(props.item);
  }, [props.item]);

  if (!bannerItem) return null;

  return (
    <Container onClick={onClickContent}>
      <div
        className="thumbnail__container"
        style={{ backgroundImage: `url(${bannerItem?.thumbNailImgUrl})` }}
      />
      <div className="banner__content__container">
        <div className="banner__content__row">
          <span className="banner__content__row__title">게시일</span>
          <span>{getYMD(bannerItem.openDate)}</span> ~{" "}
          <span>{getYMD(bannerItem.closeDate)}</span>
        </div>
        <div className="banner__content__row">
          <span className="banner__content__row__title">연결링크</span>
          <span>{bannerItem.linkUrl}</span>
        </div>
      </div>
      <MenuContainer className="menu__controller">
        <Trash
          className="icon"
          onClick={(e) => {
            e.stopPropagation();
            updateDeleteConfirmOpen(true);
          }}
        />
        <Toggle isEditable />
      </MenuContainer>

      <ModalLayout isOpen={deleteConfirmOpen}>
        <ConfirmModal
          type="confirm"
          message="선택하신 배너를 삭제 하시겠습니까?"
          onClickNegativeBtn={() => updateDeleteConfirmOpen(false)}
          onClickPositiveBtn={onClickDelete}
        />
      </ModalLayout>
    </Container>
  );
};

const Container = styled.li`
  position: relative;
  width: 100%;
  max-width: 706px;
  height: 106px;
  margin: 0 auto;
  display: flex;
  flex-direction: row;
  cursor: pointer;
  padding: 24px;
  border: 1px solid rgba(55, 53, 47, 0.16);

  .thumbnail__container {
    height: 100%;
    aspect-ratio: 249 / 106;
    border-left: 1px solid rgba(55, 53, 47, 0.16);
    background-repeat: no-repeat;
    background-size: 100% 100%;
  }

  .banner__content__container {
    flex: 4 1 180px;
    display: flex;
    flex-direction: column;
    padding: 12px 14px 14px;
    overflow: hidden;
    text-align: left;
    .banner__content__row {
      display: flex;
      flex-direction: row;
      gap: 10px;
      .banner__content__row__title {
        width: 100px;
      }
    }

    .banner__link {
      margin-top: 6px;
      line-height: 16px;
      color: rgb(55, 53, 47);
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
  :hover {
    .menu__controller {
      display: flex;
    }
  }
`;

const MenuContainer = styled.div`
  position: absolute;
  min-width: 36px;
  height: 36px;
  display: none;
  flex-direction: row;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  gap: 8px;
  padding: 0 8px;
  top: 0;
  right: 0;
  transform: translate(20%, -50%);
  background-color: rgba(255, 255, 255, 1);
  border: 1px solid grey;

  .icon {
    width: 20px;
    min-width: 20px;

    height: 20px;
    min-height: 20px;
    max-height: 20px;
    svg {
      fill: white;
    }
  }
`;
export default React.memo(BannerCard);
